<template>
	<div class="col-12">
		<div class="panel_header">
			<div class="row align-items-end">
				<div v-if="block.block_title" class="col-12">
					<h2>{{ block.block_title }}</h2>
				</div>
				<div v-if="block.subtitle" class="col-12">
					<p>{{ block.subtitle }}</p>
				</div>
			</div>
		</div>

		<div v-if="okSuccessMessage">
			<div>
				<div>
					<h4 class="title title-lg mb-4">
						{{ okSuccessMessage.title }}
					</h4>
					<div v-html="okSuccessMessage.value" />
				</div>
				<div
					v-if="okSuccessMessage.is_button_enabled == 1"
					class="p-4 w-lg-50"
				>
					<a :href="okSuccessMessage.button_link">
						<b-button variant="primary">
							{{ okSuccessMessage.button_text }}
						</b-button>
					</a>
				</div>
			</div>

			<FormulateInput
				type="button"
				@click="onClickAgainSubmit"
			>
				Отправить форму повторно
			</FormulateInput>
		</div>
		<div v-else>
			<FormulateForm
				v-if="mounted && autocompleted"
				v-model="formValues"
				:schema="$auth.user || userCheckPassed ? schema : {}"
				class="row"
				@submit="sendData($event)"
				@setCompanyInfo="setCompanyInfo"
				@onChangeSwitchMiddleName="onChangeSwitchMiddleName"
				@setValidation="setValidation"
				@setDisabled="setDisabled"
				@validatePhone="validatePhone"
			>
				<template v-if="$auth.user || userCheckPassed">
					<div
						v-if="!studyStatusCheck && block.id !== 35671695"
						class="col-12"
					>
						<FormulateInput
							class="mb-3"
							type="checkbox"
							name="needVerifyAlumni"
							data-action="panels-need-verify-alumni"
						>
							<template #label="{ id }">
								<label :for="id" class="ml-2">
									Я получаю диплом в этот день
								</label>
							</template>
						</FormulateInput>
					</div>
					<div v-if="allProductsFromGroup" class="col-12 order-0">
						<div class="row">
							<div class="col-12 col-lg-6">
								<products-component
									v-model="products"
									:block="block"
									@handlerChange="handlerChange"
								/>
							</div>
						</div>
					</div>
					<div class="col-12 col-lg-6 order-2 mb-4 mb-lg-0">
						<div class="mb-4">
							<label class="mb-2" for="promocode">Промокод</label>
							<div
								class="formulate-promocode"
								:class="isActivatePromocode ? 'formulate-promocode--active' : ''"
							>
								<FormulateInput
									v-if="!isActivatePromocode"
									id="promocode"
									v-model.trim="promocode"
									type="text"
									name="promo"
									placeholder="Промокод"
									class="px-0 mb-0 mr-2 promocode-input col"
								/>
								<div v-else class="formulate-promocode--active__text px-0 col">
									Промокод применен
								</div>
								<div
									v-if="promocode.length > 0 && !isActivatePromocode"
									@click="checkPromocodeLanding"
								>
									<icon-arrow-right
										class="arrow-right--black"
									/>
								</div>
								<div
									v-else-if="isActivatePromocode"
									class="close"
									@click="resetPromocode"
								/>
							</div>
							<div
								class="formulate-promocode__error"
							>
								{{ promocodeMessage }}
							</div>
						</div>
					</div>
					<div
						v-if="(isAuthorized && block.authentication_required)
							|| !block.authentication_required"
						class="col-12 order-10"
					>
						<div class="row">
							<div v-for="product in order.data.products" :key="product.id" class="col-12">
								<charge-points v-if="order.data.products.type !== 1" v-model="loyaltyData" :price="productsSum" />
							</div>
							<div class="col-12">
								<div v-html="block.footer_text" />
							</div>
							<div v-if="!formValues.needVerifyAlumni" class="col-12 col-lg-6">
								<div class="amount_block mt-3 mb-3">
									<div
										class="d-flex justify-content-between align-items-center"
									>
										<span class="title">Итого</span>
										<span
											v-if="(productsSumWithDiscount || productsSumWithDiscount === 0)
												&& !priceWithPromocode"
											class="title"
										>
											{{ createMaskAmount(productsSumWithDiscount) }} руб
										</span>
										<span v-else-if="priceWithPromocode" class="title">
											{{ createMaskAmount(priceWithPromocode) }} руб
										</span>
										<span v-else class="title">
											{{ createMaskAmount(0) }} руб
										</span>
									</div>
									<div
										v-if="productsSum && productsSum !== productsSumWithDiscount"
										class="d-flex justify-content-end align-items-center"
									>
										<span class="original_amount">
											{{ createMaskAmount(productsSum) }} руб
										</span>
									</div>
									<div
										v-else-if="priceWithPromocodeWithoutDiscount"
										class="d-flex justify-content-end align-items-center"
									>
										<span class="original_amount">
											{{ createMaskAmount(priceWithPromocodeWithoutDiscount) }} руб
										</span>
									</div>
								</div>
							</div>
							<div class="col-12 mb-4" v-if="block.id !== 35671695">
								<agreement-input />
								<advertising-mailings-input />
								<b2b-alumni-input v-if="block.showb2bAlumniInput" />

							</div>
							<div class="col-12">
								<FormulateInput
									type="submit"
									class="mt-2"
									:disabled="isLoadingSubmit"
								>
									<b-spinner
										v-if="isLoadingSubmit"
										style="margin-right: 15px; width: 1.3em; height: 1.3em;"
									/>
									{{ isLoadingSubmit ? 'Идет отправка формы...' : 'Зарегистрироваться' }}
								</FormulateInput>
								<CookieError v-if="isErrorCookie" />
							</div>
						</div>
					</div>

					<div v-else>
						<div class="col-12 mb-3">
							Необходимо быть зарегистрированным в системе
						</div>
						<FormulateInput
							type="button"
							class="mb-0 col-12"
							:disabled="isLoadingSubmit"
							@click="showLoginPopup"
						>
							Авторизоваться
						</FormulateInput>
					</div>
				</template>
				<template v-else>
					<div class="col-12">
						<FormulateInput
							name="email"
							type="email"
							validation="bail|^required|email|matches:/^[a-zA-Z0-9]/"
							label="Введите Email"
							validation-name="Email"
							:validation-messages="{
								'email': 'введите корректный email',
								'matches': 'введите корректный email',
								'required': 'обязательно к заполнению',
							}"
						/>

						<FormulateInput
							type="submit"
							class="mt-2"
							:disabled="isLoadingSubmit"
						>
							<b-spinner
								v-if="isLoadingSubmit"
								style="margin-right: 15px; width: 1.3em; height: 1.3em;"
							/>
							{{ isLoadingSubmit ? 'Проверяем...' : 'Продолжить' }}
						</FormulateInput>
					</div>
				</template>
			</FormulateForm>
		</div>
	</div>
</template>

<script>
import formulateFormScenario from '~/mixins/formulateFormScenario';
import ProductsComponent from '~/components/panels/formulate/products/ProductsComponent.vue';
import AgreementInput from '~/components/panels/formulate/products/components/AgreementInput.vue';
import AdvertisingMailingsInput from '~/components/panels/formulate/products/components/AdvertisingMailingsInput.vue';
import b2bAlumniInput from '~/components/panels/formulate/products/components/b2bAlumniInput.vue';
import IconArrowRight from '~/static/svg/icon-arrow-right.vue';
import ChargePoints from '~/components/formulate/loyalty/ChargePoints.vue';
import CookieError from '~/components/panels/formulate/products/components/CookieError.vue';
import moment from '@/utils/moment';

import {
	FORMULATE_ORDER_STATUSES,
	ORDER_TYPES,
	ORDER_TYPE,
	STUDY_STATUSES,
} from '~/utils/dictionaries';

export default {
	components: {
		ChargePoints,
		AgreementInput,
		ProductsComponent,
		IconArrowRight,
		AdvertisingMailingsInput,
		CookieError,
		b2bAlumniInput,
	},
	mixins: [formulateFormScenario],
	data() {
		return {
			productsSumWithDiscount: null,
			productsSum: null,
			productsCount: [],
			loyaltyData: null,
			statuses: FORMULATE_ORDER_STATUSES,
			STUDY_STATUSES,
			types: ORDER_TYPES,
			ORDER_TYPE,
			order: {
				data: {
					products: [],
				},
			},
			userExists: false,
			needRegistration: false,
			userCheckPassed: null,
			email: null,
			studyStatus: null,
		};
	},
	computed: {
		studyStatusCheck() {
			const program = this.studyStatus?.formulate_products
				.some((el) => el.graduation_this_year == 1
					&& el.study_status === STUDY_STATUSES.STUDY_STATUS_ALUMNI);
			return !!program;
		},
	},
	watch: {
		'$auth.user': {
			handler(user) {
				if (user) {
					this.handlerChange(this.selectedProducts);
					this.checkUserExists(user);
				}
			},
		},
		isActivatePromocode: {
			handler(value) {
				if (value) {
					this.productsSum = null;
					this.productsSumWithDiscount = null;
				} else {
					this.handlerChange(this.selectedProducts);
				}
			},
		},
	},
	created() {
		if (this.$auth.user) {
			this.checkUserExists(this.$auth.user);
		}
		this.checkBlock();
	},
	methods: {
		sendData(data) {
			if (this.$auth.user || this.userCheckPassed) {
				this.submit(data);
			} else {
				this.checkUserExists(data);
			}
		},

		async handlerChange(selected) {
			this.productsCount = selected;

			await this.$api.getSumProducts({
				form_scenario_id: this.block.scenario_id,
				email: this.email ?? this.formValues.email,
				products: selected.map((el) => ({
					id: el.id,
					quantity: el.quantity,
					price: +el.price,
				})).filter((el) => el.quantity !== 'Выберите количество'),
				promocode: this.isActivatePromocode ? this.promocode : null,
			}).then((res) => {
				this.priceWithPromocode = null;
				this.priceWithPromocodeWithoutDiscount = null;
				this.productsSumWithDiscount = res.sum;
				this.productsSum = res.sumWithoutDiscount;
			});
		},
		checkPromocodeLanding() {
			this.checkPromocode(this.productsCount.filter((el) => el.quantity !== 'Выберите количество'));
		},
		checkBlock() {
			if (this.block.id === 35671695) {
				this.userCheckPassed = true;
			} else {
				this.userCheckPassed = false;
			}
		},
		getData() {
			let userData = this.formValues;

			if (!this.agreements.marketing_emails) {
				this.agreements.marketing_emails = !!this.formValues.advertisingMailingsAgreement;
			}
			if (!this.agreements.personal_data) {
				this.agreements.personal_data = !!this.formValues.personalData;
			}

			this.setAgreementFields();

			userData = {
				sklTargetAction: this.block.form_scenario_action_label,
				sklAgreeSubscribeLookup: this.formValues.advertisingMailingsAgreement ? 'да' : 'нет',
				sklBirthDate: this.formValues.birthday ? moment(this.formValues.birthday).format('DD.MM.YYYY') : '',
				...userData,
				...this.getAnalyticsData(),
				...{ can_return_vat_selected: +this.can_return_vat_selected },
			};

			const data = {
				user_data: userData,
				products: this.selectedProducts ?? null,
				entity_name: this.fetchedData.entity_name,
				entity_id: this.fetchedData.id,
				loyaltyData: this.loyaltyData,
			};

			if (this.isActivatePromocode) {
				data.user_data.promo = this.promocode;
			}

			return data;
		},
		async checkUserExists(data) {
			try {
				this.isLoadingSubmit = true;

				await this.$api.userExists({
					email: data.email,
				}).then((res) => {
					this.studyStatus = res.data;
				});

				this.userExists = true;
			} catch {
				this.needRegistration = true;
			} finally {
				this.userCheckPassed = true;
				this.email = data.email;
				this.isLoadingSubmit = false;

				this.$set(this.formValues, 'email', data.email);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.formulate-form, .custom-control-label, .formulate-input, .formulate-input .formulate-input-label {
  font-family: $font-family-base !important;
  font-weight: 500 !important;
}

.field-required {
  &.formulate-input[data-classification='text'] input {
    border: 1px solid red !important;
  }
}

span {
  margin: 0;
  line-height: 1.3;

  &.price-muted {
    font-size: 1.5rem;
    text-decoration: line-through;
    color: $border-color;
  }
}

.arrow-right {
  &--black {
    fill: black;
    padding: 0;
    cursor: pointer;
  }
}

.close {
  cursor: pointer;
  opacity: 1;
}

.close::before {
  content: '\e915';
  font-size: 1rem;
}

.amount_block {
  height: 3rem;

  .original_amount {
    color: $border-color;
    font-weight: bold;
    text-decoration: line-through;
  }
}
</style>
